// src/components/pages/message/timecapsule/TimeCapsuleWizard.js

import React, { useState, useMemo, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { NAVBAR_HEIGHT } from "../../../../constants/constants";
import Step1Compose from "./Step1Compose";
import Step2Recipients from "./Step2Recipients";
import Step3Review from "./Step3Review";
import { Box, Stepper, Step, StepLabel } from "@mui/material";

const steps = ["Compose", "Recipients", "Review"];

const TimeCapsuleWizard = () => {
  // Read location data from query string
  const [searchParams] = useSearchParams();
  const initialLat = parseFloat(searchParams.get("lat")) || 0;
  const initialLng = parseFloat(searchParams.get("lng")) || 0;
  const initialAddress = searchParams.get("address") || "";

  // Wizard step (0 = Step1, 1 = Step2, 2 = Step3)
  const [activeStep, setActiveStep] = useState(0);

  // Store wizard data in state
  const [wizardData, setWizardData] = useState({
    // Location info from DropMessagePage
    lat: initialLat,
    lng: initialLng,
    address: initialAddress,

    // Step 1 data
    subject: "",
    message: "",
    mediaFile: null, // or an object with { url, type } if you want to store a preview

    // Step 2 data
    recipients: [],
    phoneNumbers: [],
    dropCount: 10, // default
    dropUnit: "weeks", // default

    // Step 3 data (mostly read-only display)
  });

  useEffect(() => {
    // whenever the step changes, jump back to top
    window.scrollTo(0, 0);
  }, [activeStep]);

  const handleNext = () => {
    if (activeStep < steps.length - 1) {
      setActiveStep((prev) => prev + 1);
    }
  };

  const handleBack = () => {
    if (activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  // We can conditionally render each step component
  // passing down wizardData and a setter to update it.
  const currentStepContent = useMemo(() => {
    switch (activeStep) {
      case 0:
        return (
          <Step1Compose
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
          />
        );
      case 1:
        return (
          <Step2Recipients
            wizardData={wizardData}
            setWizardData={setWizardData}
            onNext={handleNext}
            onBack={handleBack}
          />
        );
      case 2:
        return (
          <Step3Review
            wizardData={wizardData}
            setWizardData={setWizardData}
            onBack={handleBack}
          />
        );
      default:
        return <div>Unknown step</div>;
    }
  }, [activeStep, wizardData]);

  return (
    <Box
      sx={{
        p: 4,
        backgroundColor: "white",
        height: `calc(100vh - ${NAVBAR_HEIGHT}px)`,
      }}
    >
      {/* Step Indicator */}
      <Stepper activeStep={activeStep} sx={{ mb: 2 }}>
        {steps.map((label) => (
          <Step key={label}>
            <StepLabel>{label}</StepLabel>
          </Step>
        ))}
      </Stepper>

      {/* Render the step's content */}
      {currentStepContent}
    </Box>
  );
};

export default TimeCapsuleWizard;
